// extracted by mini-css-extract-plugin
export var askAiIcon = "_k0-9";
export var container = "_k0-0";
export var groupSeparator = "_k0-a";
export var highlight = "_k0-4";
export var resultIcon = "_k0-5";
export var resultItem = "_k0-7";
export var resultSubtitle = "_k0-3";
export var resultTitle = "_k0-2";
export var resultsList = "_k0-1";
export var searchGroup = "_k0-6";
export var selected = "_k0-8";